export default __webpack_public_path__ + "static/media/printer.eae905c7.svg";